/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  if(typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.cartDoctor !== 'undefined') {
    cart = window.BOLD.common.cartDoctor.fix(cart);
}
   
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {

  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if(typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.cartDoctor !== 'undefined') {
    cart = window.BOLD.common.cartDoctor.fix(cart);
}
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body);
  
  var before_callback = function(jqxhr, settings){
    
    $body.trigger('beforeAddItem.ajaxCart', form);
  }
  
  var success_callback = function(line_item) {
    if ((typeof callback) === 'function') {
      callback(line_item, form);
    }
    else {
      ShopifyAPI.onItemAdded(line_item, form);
    }
    $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
  }
  
  var error_callback = function(XMLHttpRequest, textStatus) {
    if ((typeof errorCallback) === 'function') {
      errorCallback(XMLHttpRequest, textStatus);
    }
    else {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
    $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
  }

  if(typeof(BOLD)==='object' && BOLD.helpers && typeof(BOLD.helpers.addItemFromForm) === 'function') {
   
    BOLD.helpers.addItemFromForm($(form), success_callback, error_callback, {endpoint:'/cart/add.js'}); 
   
  } else {
    var $body = $(document.body),
        params = {
          type: 'POST',
          url: '/cart/add.js',
          data: jQuery(form).serialize(),
          dataType: 'json',
          beforeSend: before_callback,
          success: success_callback,
          error: error_callback,
          complete: function(jqxhr, text) {
            $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
          }
        };
    jQuery.ajax(params);
  }
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) { 
        $('.template-product').addClass("loading");   
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  
    //Boldfix disable checkout on change begin
  var checkout = document.querySelector('.ajaxcart__footer');
  checkout.style = "pointer-events:none; opacity: 0.4;";
  setTimeout(function(){checkout.style = "pointer-events:inital; opacity: 1;"},2500);
  //Boldfix disable checkout on change end

  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if(typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.cartDoctor !== 'undefined') {
    cart = window.BOLD.common.cartDoctor.fix(cart);
}
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
      
    }
  };

  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
     document.cookie = 'discount_code=SHINE25';
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if(typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.cartDoctor !== 'undefined') {
    cart = window.BOLD.common.cartDoctor.fix(cart);
}
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');
   
    ShopifyAPI.getCart(cartUpdateCallback);
  
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
   
  };

  buildCart = function (cart) {
    // Bold:POv2.3 HYBRID
if(typeof BOLD === 'object' && BOLD.options){
  BOLD.options.app.registerCartRenderFunction(buildCart);
}
     if(typeof window.BOLD !== 'undefined'
        && typeof window.BOLD.common !== 'undefined'
        && typeof window.BOLD.common.cartDoctor !== 'undefined') {
       // NOTE: "cart" should be the variable containing the cart json data
       cart = window.BOLD.common.cartDoctor.fix(cart);
     }

    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p>' + "Your cart is currently empty." + '</p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);
		var shippablePrice = 0
    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      
      

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      var ItemShipPrice = 0
      if (cartItem.requires_shipping){
      ItemShipPrice = cartItem.line_price;
      }else{ ItemShipPrice = 0;}
      
      shippablePrice += ItemShipPrice; parseInt( $(this).text() );
      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: cartItem.raw_line_index ? cartItem.raw_line_index + 1 : index + 1, // Bold:PO 2.0 - Hybrid Fix
        url: cartItem.url,
        img: prodImg,
        sku: cartItem.sku,
        name: cartItem.product_title,
        type: cartItem.product_type,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
      };

      items.push(item);

    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalQty: cart.item_count,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      cartPrice: cart.total_price,
      freeshipPrice: Shopify.formatMoney(5500 - shippablePrice, settings.moneyFormat),
      freeship: shippablePrice > 5490 ? false : true,
      gwp: shippablePrice > 3900 ? false : true,
      shippablePrice: shippablePrice,
      totalCartDiscount: cart.total_discount === 0 ? 0 : Shopify.formatMoney(cart.total_discount, settings.moneyFormat),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    }

    $cartContainer.append(template(data));

    cartCallback(cart);
                 

    
    if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
          typeof BOLD.common.eventEmitter.emit === 'function'){
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
      }

  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
    if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
          typeof BOLD.common.eventEmitter.emit === 'function'){
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
      }
    $(".ajaxcart__product-meta").each(function(){
    	var name = $(this).text();
      	if(name.indexOf("update") != -1)
        {
           $(this).parents(".ajaxcart__product").hide();
        }
    });
    $(".ajaxcart__product-meta").each(function(){
    	var prop = $(this).text();
      	var prop = prop.replace(/\s+/g, "");
        var n1 = $(this).siblings(".ajaxcart__product-name").text();
      	var n1 = n1.replace(/\s+/g, "");
        $(".ajaxcart__product-name").each(function(){
            var name = $(this).text();
          	var name = name.replace(/\s+/g, "");
            if(prop.indexOf(name.replace("-PartofSet","")) != -1 || prop.indexOf(name.replace("-partofset","")) != -1)
            {
              $(this).parents(".ajaxcart__product").addClass(n1);
            }
        });
    });

  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {


      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
        // Update the live region for screen readers
    document.getElementById('screenReaderAlert').textContent = 'Quantity Increased';
      } else {
        qty -= 1;
         document.getElementById('screenReaderAlert').textContent = 'Quantity Decreased';
        if (qty <= 0) qty = 0;
         document.getElementById('screenReaderAlert').textContent = 'Item Removed from Cart';
      }
      
      var idnt = $(this).parents(".two-thirds").find(".ajaxcart__product-name").text();
      var idnt = idnt.replace(/\s+/g, "");
      
      $(".ajaxcart__product").each(function(){
        if($(this).hasClass(idnt))
        {
          console.log(qty);
          var id1 = $(this).find(".ajaxcart__product-meta").text();
          var id1 = id1.replace("update: update_","");
          $.ajax({
	      type: 'POST',
          url: '/cart/change.js',
	      dataType: 'json',
          async:false,
	      data: 'id='+ id1 + '&quantity='+qty,
	      success: function(res){
            console.log("done");
          }
          });
//            $(".site-header__cart").trigger("click");
          if(qty == 0)
          {
            line = parseInt(line) - 1;
            console.log("line="+line);
          }
        }
      });

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
        
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
        
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');
      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      buildCart(cart)
    }, 150)
  };

  // Quick Add Function
  var quickAdd = $('.quick-add');

  quickAdd.click(function(evt){
    evt.preventDefault();

    var quickAdd = jQuery.post('/cart/add.js', {
      quantity: 1,
      id: $(this).data('id')
    }).always(function(){
      ShopifyAPI.getCart(cartUpdateCallback);
    });
// Update the live region for screen readers
    document.getElementById('screenReaderAlert').textContent = 'Item added to bag';

  });

 // Quick Add Multiple Function  
var quickAddMultiple = $('.quick-add-multiple');

quickAddMultiple.click(function(evt){
    evt.preventDefault();

    // Get the button element
    var $button = $(this);

    // Get the list of product IDs from the data attribute
    var productIds = $button.data('ids').split(',');

    // Disable the button and change text
    $button.prop('disabled', true).text('Adding items to bag...');

    // Function to add a single product to the cart
    function addProductToCart(id) {
        return jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: id
            },
            dataType: 'json'
        });
    }

    // Add products to cart sequentially
    productIds.reduce(function(promise, id) {
        return promise.then(function() {
            return addProductToCart(id);
        });
    }, Promise.resolve()).then(function() {
        // After all products have been added, update the cart and restore button state
        ShopifyAPI.getCart(cartUpdateCallback);
        document.getElementById('screenReaderAlert').textContent = 'Items added to bag';
        $button.prop('disabled', false).text('Add set to bag');
    }).catch(function(error) {
        console.error('Error adding products to cart:', error);
        $button.prop('disabled', false).text('Add set to bag');
    });
});

  
 $('.quick-adder').click(function(){
   $.ajax({
        url: '/cart/update.js',
        method: 'POST',
        dataType: 'json',
        data: {
          updates: {[42349877919786]: 1}
         }
          }); 
   $('.bill-add').hide();
      });

  	
        




  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
            if (qty >=60) qty = 60;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));

window.theme = window.theme || {};

theme.CartDrawer = new theme.Drawers('CartDrawer', 'right', {
  onDrawerOpen: ajaxCart.load
})

jQuery(function($) {
  ajaxCart.init({
    formSelector: '.product-form',
    cartContainer: '#CartContainer',
    addToCartSelector: '.product-form__cart-submit',
    cartCountSelector: '#CartCount span',
    cartCostSelector: '#CartCost',
    moneyFormat: theme.moneyFormat
  });
});

Handlebars.registerHelper('if_eq', function(a, b, opts) {
    if (a.trim() == b.trim()) {
        return opts.fn(this);
    } else {
        return opts.inverse(this);
    }
});

// Bind to 'afterCartLoad.ajaxCart' to run any javascript after the cart has loaded in the DOM
jQuery(document.body).on('afterCartLoad.ajaxCart', function(evt, cart) {
  theme.CartDrawer.open();
   $('.template-product').removeClass("loading"); 
    $('.wait').hide();

$('.bold-clone').on('click',function(){
   $('#CartDrawer').removeAttr("tabindex");
 
 });


    function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}
  
  waitForElm('#bold-modal__window').then((elm) => {
   $('#bold-modal__window').attr("tabindex" , -1);
   $('#bold-modal__window').focus();
    $('#bold-modal__btn-close').attr("aria-label" , "close");
    $('#bold-modal__btn-close').attr("aria-role" , "button");
    
     });
  
$('.cart__checkout').click(function (e) {
  e.preventDefault(); // Prevent default form submission

  // Check if the gift note textarea is empty or only contains whitespace
  if (!$.trim($("#gift_note_textarea").val())) {
    // If empty, set gift note product quantity to 0
    $.ajax({
      url: '/cart/update.js',
      method: 'POST',
      dataType: 'json',
      data: {
        updates: { '32095265620010': 0 } // Adjust to your gift note product variant ID
      },
      success: function() {
        // Proceed to checkout after updating the cart
        window.location.href = '/checkout';
      },
      error: function() {
        alert('Error updating cart');
      }
    });
  } else {
    // If note is present, set gift note product quantity to 1
    $.ajax({
      url: '/cart/update.js',
      method: 'POST',
      dataType: 'json',
      data: {
        updates: { '32095265620010': 1 } // Adjust to your gift note product variant ID
      },
      success: function() {
        // Proceed to checkout after updating the cart
        window.location.href = '/checkout';
      },
      error: function() {
        alert('Error updating cart');
      }
    });
  }
});
   // Quick Add
  



  
});


